import React from "react";
import { Portait2Style } from "./css/Portrait2Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const Template = (props) => {
  return (
    <Portait2Style>
      <div className="poster nine-by-sixteen lg flex-column">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="text-wrapper flex-column">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
        <div className="video-outer">
          <div className="video-container">
            <TemplateImage slideType={props.slideType} file={props.file} />
          </div>
        </div>
      </div>
    </Portait2Style>
  );
};

export default Template;
